import { isPlatformBrowser } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment, domainAPI } from "@environments/environment";

export interface ENRUser {
  user_id: string;
  username: string;
  email: string;
  status: string;
  created_by: string;
  updated_by: string;
  created_date: Date;
  updated_date: Date;
}

@Injectable({ providedIn: "root" })
export class ENRUserService {
  readonly routerAPI = {
    getAllUsers: "/api/getAllUsers",
    getUserById: (username: string) => `/api/getUserByName/${username}`,

    // User Customization API
    getAndCreateUserCustomization: domainAPI.enricher + "/user-customizations",
    getUserCustomizationById:
      domainAPI.enricher + "/user-customizations/{userId}",
  };

  private readonly http = inject(HttpClient);
  private readonly platformId = inject(PLATFORM_ID);

  getAll(): Observable<ENRUser[] | []> {
    if (isPlatformBrowser(this.platformId)) {
      return this.http.get<ENRUser[]>(`${this.routerAPI.getAllUsers}`);
    }
    return of([]);
  }

  getByUsername(username: string): Observable<ENRUser | null> {
    if (isPlatformBrowser(this.platformId)) {
      return this.http.get<ENRUser>(this.routerAPI.getUserById(username));
    }
    return of(null);
  }

  getListUser(queryParams: any): Observable<any | null> {
    return this.http.get<ENRUser>(`${environment.domain.enricher}/user`, {
      params: queryParams,
    });
  }

  getUserCustomization(queryParams?: any): Observable<any | null> {
    return this.http.get<any>(
      `${this.routerAPI.getAndCreateUserCustomization}`,
      {
        params: queryParams,
      },
    );
  }
  getUserCustomizationById(userId: string): Observable<any | null> {
    return this.http.get<any>(
      `${this.routerAPI.getUserCustomizationById}`.replace("{userId}", userId),
    );
  }

  createUserCustomization(payload: any): Observable<any | null> {
    return this.http.post<any>(
      `${this.routerAPI.getAndCreateUserCustomization}`,
      payload,
    );
  }
}
